import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, Checkbox, FormControlLabel, MenuItem, InputLabel, FormControl } from '@mui/material';
import Portal from '@mui/base/Portal';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import AgentSelect from '../agents/AgentSelect';
import TagsOptions from '../components/TagsOptions';
import axios from 'axios'; 
import moment from 'moment';
import ContactsSelect from '../contacts/ContactsSelect';
import {getVisibility} from '../commonfun/common';
import {API_URL} from '../utils/EnvVars';
import Cookies from 'js-cookie';

// const StyledTableCell = styled(TableCell)({
//   padding: "3px 0px 3px 5px",
// })

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const childRefContacts = React.useRef();
  const childRefPartners = React.useRef();
  const childRefUser = React.useRef();
  const duplicateMobileFlag = Cookies.get('duplicateMobileFlag');
  const duplicateEmailFlag = Cookies.get('duplicateEmailFlag');
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  
	const [channelList, setChannelList] = React.useState([]);
	const [leadStatusDataList, setLeadStatusDataList] = React.useState([]);
  const [leadStatusList, setLeadStatusList] = React.useState([]);
  const [leadTypesList, setLeadTypesList] = React.useState([]);
  const [leadSourcesList, setLeadSourcesList] = React.useState([]);
  const [leadTagsList, setLeadTagsList] = React.useState([]);
  const [industryList, setIndustryList] = React.useState([]);
  const [leadLossReasonsList, setLeadLossReasonsList] = React.useState([]);
  const [campaigns, setCampaigns] = React.useState([]);
  
  const [title, setTitle] = React.useState("");
  const [remarks, setRemarks] = React.useState("");
  const [channelId, setChannelId] = React.useState(0);
  const [channelName, setChannelName] = React.useState("");
  const [tags, setTags] = React.useState([]);
  const [source, setSource] = React.useState("");
  const [status, setStatus] = React.useState("noselect");
  const [parentStatus, setParentStatus] = React.useState("");
  const [statusOld, setStatusOld] = React.useState("noselect");
  const [leadType, setLeadType] = React.useState("");
  const [leadLossReason, setLeadLossReason] = React.useState("");
  const [leadAccountType, setLeadAccountType] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [accountName, setAccountName] = React.useState("");
  const [accountId, setAccountId] = React.useState("");
  const [partnerAccountNumber, setPartnerAccountNumber] = React.useState("");
  const [partnerAccountName, setPartnerAccountName] = React.useState("");
  const [partnerAccountId, setPartnerAccountId] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [designation, setDesignation] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [website, setWebsite] = React.useState("");
  const [rating, setRating] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [amountOld, setAmountOld] = React.useState(0);
  const [amount, setAmount] = React.useState(0);
  const [campaignIdOld, setCampaignIdOld] = React.useState(0);
  const [campaignId, setCampaignId] = React.useState(0);
  const [campaignName, setCampaignName] = React.useState("");

  const [accessType, setAccessType] = React.useState(1);
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);
  const [checkedDuplicateMobile, setCheckedDuplicateMobile] = React.useState(true);
  const [checkedDuplicateEmail, setCheckedDuplicateEmail] = React.useState(true);

  var myCurrentDate=new Date();
	var myDueDate=new Date(myCurrentDate);
  myDueDate.setDate(myDueDate.getDate() + 25);
	const [forecastCloseDate, setForecastCloseDate] = React.useState(moment(myDueDate).format('YYYY-MM-DD'));

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));

  
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    setLoadingBtn(false);
    if(duplicateMobileFlag && duplicateMobileFlag==='false'){
      setCheckedDuplicateMobile(false);
    }else{
      setCheckedDuplicateMobile(true);
    }
    if(duplicateEmailFlag && duplicateEmailFlag==='false'){
      setCheckedDuplicateEmail(false);
    }else{
      setCheckedDuplicateEmail(true);      
    }
  
    if(open && props.dataObj && props.userObj && props.dataObj.autoId && props.dataObj.autoId>0){

      setTitle(props.dataObj.title);
      setRemarks(props.dataObj.remarks);
      setChannelId(props.dataObj.channelId);
      setChannelName(props.dataObj.channelName);
      if(props.dataObj.tags){
        setTags(props.dataObj.tags.split(','));
      }
      setSource(props.dataObj.source);
      setStatus(props.dataObj.status+'$#$'+props.dataObj.parentStatus);
      setParentStatus(props.dataObj.parentStatus);
      setStatusOld(props.dataObj.status);
      setLeadLossReason(props.dataObj.lossReason);
      setLeadType(props.dataObj.leadType);
      setLeadAccountType(props.dataObj.leadAccountType);
      setPartnerAccountNumber(props.dataObj.partnerAccountNumber);
      setPartnerAccountName(props.dataObj.partnerAccountName);
      setPartnerAccountId(props.dataObj.partnerAccountId);
      setAccountNumber(props.dataObj.accountNumber);
      setAccountName(props.dataObj.accountName);
      setAccountId(props.dataObj.accountId);
      setContactName(props.dataObj.contactName);
      setMobile(props.dataObj.mobile);
      setPhone(props.dataObj.phone);
      setEmail(props.dataObj.email);
      setAddress(props.dataObj.address);
      setPincode(props.dataObj.pincode);
      setDesignation(props.dataObj.designation);
      setCompany(props.dataObj.company);
      setWebsite(props.dataObj.website);
      setRating(props.dataObj.rating);
      setIndustry(props.dataObj.industry);
      setAmount(props.dataObj.amount);
      setAmountOld(props.dataObj.amount);
      setCampaignId(props.dataObj.campaignId);
      setCampaignName(props.dataObj.campaignName);
      setCampaignIdOld(props.dataObj.campaignId);

      if(props.dataObj.forecastCloseDate){
        let dateArr = props.dataObj.forecastCloseDate.split("-");
        setForecastCloseDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }

      setOwnerAlias(props.userObj.fullName);
      setOwnerId(props.userObj.userId);

      if(props.dataObj.accessType && props.dataObj.accessType===2){
        setAccessType(props.dataObj.accessType);
      }else{
        setAccessType(1);
      }

    }else{

      setTitle("");
      setRemarks("");
      setChannelId(0);
      setChannelName("");
      setTags([]);
      setSource("");
      ///setStatus("noselect");
      setStatusOld("noselect");
      setLeadLossReason("");
      setLeadType("");
      setLeadAccountType("");
      setPartnerAccountNumber("");
      setPartnerAccountName("");
      setPartnerAccountId("");
      setAccountNumber("");
      setAccountName("");
      setAccountId("");
      setContactName("");
      setMobile("");
      setPhone("");
      setEmail("");
      setAddress("");
      setPincode("");
      setDesignation("");
      setCompany("");
      setWebsite("");
      setRating("");
      setIndustry("");
      setAmountOld(0);
      setAmount(0);
      setCampaignIdOld(0);
      setCampaignId(0);
      setCampaignName("");
       
      setOwnerAlias(props.userObj.fullName);
      setOwnerId(props.userObj.userId);

      if(props.userObj && open){
        if(props.userObj.visibilityJson && props.userObj.visibilityJson.length>2){
          setAccessType(getVisibility(props.userObj.visibilityJson,'Leads'));
        }
      }

    }

    if(props.userObj && open){
      getApiDataMultiple();       
    }

	}, [props.userObj,open]);
  


  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

	function saveData(){
    if(!title || (title && title.length<1) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter title");			
      return false;
    }
    if(!contactName || (contactName && contactName.length<1) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter contact name");			
      return false;
    }
    if(!mobile || (mobile && mobile.length<1) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter mobile");			
      return false;
    }else if(mobile && mobile.length!==10){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter valid mobile number");			
      return false;
    }
    if(email && email.length>0 && !validateEmail(email) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Email is not valid.");			
      return false;
    }
    if(!channelId || (channelId && channelId<1)){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select channel");			
      return false;
    }
    if(!status || (status && status==='noselect')){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select status");			
      return false;
    }

		if(title && contactName && mobile){ 
      
      let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      let changeCampaignFlag = 0;
      const data = new FormData();
    
      if(title){
        data.append('title', title);
      }
      if(channelId){
        data.append('channelId', channelId);
        data.append('channelName', channelName);
      }
      if(contactName){
        data.append('contactName', contactName);
      }
      if(mobile){
        data.append('mobile', mobile);
      }
      if(phone){
        data.append('phone', phone);
      }
      if(email){
        data.append('email', email);
      }
      if(address){
        data.append('address', address);
      }
      if(pincode){
        data.append('pincode', pincode);
      }
      if(website){
        data.append('website', website);
      }
      if(leadType){
        data.append('leadType', leadType);
      }
      if(source){
        data.append('source', source);
      }
      if(industry){
        data.append('industry', industry);
      }    
      
      if(amount && amount>0){
        data.append('amount', amount);
      }else{
        data.append('amount', 0);
      }
      if(amount!==amountOld){
        changeCampaignFlag = 1;
      }
      if(designation){
        data.append('designation', designation);
      }
      if(company){
        data.append('company', company);
      }
      if(rating){
        data.append('rating', rating);
      }
      if(remarks){
        data.append('remarks', remarks);
      } 

      if(status && status.length>0 && status!=='noselect'){
        let statusArr = status.split('$#$');
        data.append('status', statusArr[0]);
        data.append('parentStatus', statusArr[1]);
        if("Lost"===statusArr[1]){
            data.append('reason', leadLossReason);
        }
        if(statusOld!==statusArr[0]){
          data.append('statusChanged', 1);
          changeCampaignFlag = 1;
        }else{
          data.append('statusChanged', 0);
        }
      }
      
      
      if(accountName){
        data.append('accountName', accountName);
      }
      if(accountId){
        data.append('accountId', accountId);
      }
      if(accountNumber){
        data.append('accountNumber', accountNumber);
      }

      if(partnerAccountId && parseInt(partnerAccountId)>0){
        data.append('partnerAccountName', partnerAccountName);
        data.append('partnerAccountId', partnerAccountId);
        data.append('partnerAccountNumber', partnerAccountNumber);
      }

      if(campaignId && parseInt(campaignId)>0){
        data.append('campaignId', campaignId);
        data.append('campaignName', campaignName);
      }else{
        data.append('campaignId', 0);
      }
      
      if(campaignId!==campaignIdOld){
        changeCampaignFlag = 1;
      }

      if(tags && tags.length>0){
        data.append('tags', tags.join(','));
      }else{
        data.append('tags', '');
      }
      
      if(leadAccountType){
        data.append('leadAccountType', leadAccountType);
      }

      if(forecastCloseDate){
        data.append('forecastCloseDate', moment(forecastCloseDate).format('YYYY-MM-DD'));
      }
      
      if(ownerId){
        data.append('ownerAlias', ownerAlias);
        data.append('ownerId', ownerId);
      }

      if(accessType){
        data.append('accessType', accessType);
      }
      
      //data.append('accessWithType', accessWithType);
      //data.append('accessWithNames', accessWithNames);
      //data.append('accessWithIds', accessWithIds);

      if(props.fullList===true){
        data.append('fullList', 1);
      }else{
        data.append('fullList', 0);
      }

      if(props.detailFlag===true){
        data.append('detailFlag', 1);
      }else{
        data.append('detailFlag', 0);
      }

      if(checkedDuplicateMobile===true){
        data.append('checkedDuplicateMobile', 1);
        Cookies.set('duplicateMobileFlag', true, { expires: new Date(new Date().getTime() + 3600000*24*7) });

      }else{
        data.append('checkedDuplicateMobile', 0);
        Cookies.set('duplicateMobileFlag', false, { expires: new Date(new Date().getTime() + 3600000*24*7) });

      }

      if(checkedDuplicateEmail===true){
        data.append('checkedDuplicateEmail', 1);
        Cookies.set('duplicateEmailFlag', true, { expires: new Date(new Date().getTime() + 3600000*24*7) });

      }else{
        data.append('checkedDuplicateEmail', 0);
        Cookies.set('duplicateEmailFlag', false, { expires: new Date(new Date().getTime() + 3600000*24*7) });

      }

      if(changeCampaignFlag === 1){
        data.append('changeCampaignFlag', 1);
      }else{
        data.append('changeCampaignFlag', 0);
      }

      let apiURL = '/crm-create-leads';
      if(props.dataObj && props.userObj && open && props.dataObj.autoId && props.dataObj.autoId>0){
        data.append('leadId', props.dataObj.autoId);
        apiURL = '/crm-update-leads';
      }
      setLoadingBtn(true);
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setLoadingBtn(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Lead details has been saved.");
          if(props.fullList===true || props.accountId>0){
            props.updatedList(response.data.list);
          }else{
            props.updatedDetails(response.data.list[0]);
          }          	
					return false;

        }else if(response.data.responseTxt==="limitexceeded"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Your app records limit exceeded. You must upgrade your package to add more data.");			
					return false;  

        }else if(response.data.responseTxt==="FoundMobile"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This mobile number is already added with another lead.");			
					return false;  

        }else if(response.data.responseTxt==="FoundEmail"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This email is already added with another lead.");			
					return false;  

				}else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Lead details could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}


  function selectContacts(){
      childRefContacts.current.handleClickOpen();
	}
  function contactDetail(obj){    
    setAccountId(obj.accountId);
    setAccountName(obj.accountName);
    setAccountNumber(obj.accountNumber);
    setContactName(obj.contactName);
    setMobile(obj.mobile);
    setPhone(obj.phone);
    setEmail(obj.email);
    setAddress(obj.address);
    setPincode(obj.zipCode);    
  }

  function selectPartner(){
    childRefPartners.current.handleClickOpen();
  }
  function partnerDetail(obj){    
    setPartnerAccountId(obj.accountId);
    setPartnerAccountName(obj.accountName);
    setPartnerAccountNumber(obj.accountNumber);
  }
  
  function onEnter(event){
		if(event.key === 'Enter'){
			saveData();
		}
	}
  function numberOnly(event){
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    } 
  }
  function nameOnly(event) {
    if(!(/[a-z ]/i.test(event.key))) {
          event.preventDefault();
          return false;
      }
  }  
  function decimalOnly(event){
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    event.preventDefault();
    return true;
  }



  async function getApiDataMultiple(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': props.userObj.registerId,
			'uid': props.userObj.loginId,
			'fullName': props.userObj.fullName,
			'token': props.userObj.token,
		  }
		};

    axios.get(API_URL+'/crmix-for-leadsave', axiosHeader)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){ 
        
        if(!props.dataObj && response.data.obj.leadChannels && response.data.obj.leadChannels[0].autoId){
          setChannelId(response.data.obj.leadChannels[0].autoId);
        }
        setChannelList(response.data.obj.leadChannels);
        setLeadStatusDataList(response.data.obj.leadStatus);
        setLeadTypesList(response.data.obj.leadTypes);
        setLeadSourcesList(response.data.obj.leadSources);
        setLeadTagsList(response.data.obj.leadTags);
        setIndustryList(response.data.obj.leadIndustry);
        setLeadLossReasonsList(response.data.obj.leadLossReasons);
        setCampaigns(response.data.obj.campaigns);
        
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      } 		 				
    }).catch((error) => {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage(""+error);			
      return false;
      })
  }
  
  function selectUser(){
    childRefUser.current.handleClickOpen();
  }
  function userDetail(obj) {
    setOwnerId(obj.autoId);
    setOwnerAlias(obj.fullName);    
  }
  
  React.useEffect(() => {
    if(channelId && leadStatusDataList && leadStatusDataList.length>0){
      handleChannelId(channelId);
    }  
  }, [channelId,leadStatusDataList]);

  function handleChannelId(id) { 
		setChannelId(id);
		if(id && id>0){
      if(channelList){
        for(let i=0; i<channelList.length; i++){
          if(channelList[i].autoId===id){
            setChannelName(channelList[i].channelName);
            break;
          }
        }
      }

			let caseStatusArr = [];
			for(let i=0; i<leadStatusDataList.length; i++){
				if(leadStatusDataList[i].channelId===id){
					caseStatusArr.push(leadStatusDataList[i]);
				}
			}
			setLeadStatusList(caseStatusArr);

      if(!props.dataObj && caseStatusArr && caseStatusArr.length>0){
        setStatus(caseStatusArr[0].status+'$#$'+caseStatusArr[0].parentStatus);
      }      

		}else{
			setLeadStatusList([]);
		}
	}

  function selectedTags(arr) {
    setTags(arr);
  }

  function handleStatus(val) {
    if(val){
      setStatus(val);
      setParentStatus(val.split("$#$")[1]);
    }
  }

  React.useEffect(() => {	
    if(open && props.accountId && props.accountId>0){
      getApiDataAccountDetails(props.accountId);
    }
  }, [props.accountId,open]);

  async function getApiDataAccountDetails(aid){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': props.userObj.registerId,
			'uid': props.userObj.loginId,
			'fullName': props.userObj.fullName,
			'token': props.userObj.token,
		  }
		};
    axios.get(API_URL+'/crm-list-contacts?accountId='+aid, axiosHeader)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){ 
        if(response.data.list && response.data.list.length>0){
          setContactName(response.data.list[0].contactName);
          setAccountId(response.data.list[0].accountId);
          setAccountName(response.data.list[0].accountName);
          setAccountNumber(response.data.list[0].accountNumber);
          setMobile(response.data.list[0].mobile);
          setEmail(response.data.list[0].email);
          setPhone(response.data.list[0].phone);
          setAddress(response.data.list[0].address);
        }
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      } 		 				
    }).catch((error) => {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage(""+error);			
      return false;
      })
  }

  function handleCampaign(val){
    if(val && val.length>2){
      let valArr = val.split('#');
      if(valArr[0] && parseInt(valArr[0])>0){
        setCampaignId(parseInt(valArr[0]));
        setCampaignName(valArr[1]);
      }
    }else{
      setCampaignId(0);
      setCampaignName("");
    }
  }

  return (
    <>
      <Dialog fullWidth style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Lead</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} style={{marginRight:15}} >

                  <Box mt={2} mb={1} >
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12} >
                        {/* duplicateMobileFlag: {duplicateMobileFlag} */}
                            <FormControl fullWidth size='small' >
                                <Select native
                                defaultValue={leadType} 
                                onChange={event => setLeadType(event.target.value)}
                                >
                                <option value={'noselect'} >Lead Type</option>
                                {leadTypesList?leadTypesList.map((row,i)=>(
                                  <optgroup label={row.title} >
                                    {row.children?row.children.map((rw,j)=>(
                                      <option value={rw.title} >{rw.title}</option>
                                    )):null}
                                  </optgroup>
                                )):null}
                                </Select>
                              </FormControl>

                          <TextField required size='small' label="Lead Title" placeholder="Customer's requirement in one sentence" onChange={event => setTitle(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={title} fullWidth variant="outlined" style={{marginTop: 14}} />
                          <TextField size='small' label="Requirement in detail" placeholder="Customer's requirement in detail" onChange={event => setRemarks(event.target.value)} value={remarks} fullWidth style={{marginTop: 14}} variant="outlined" multiline  />
                          <TextField size='small' label="Tentative Lead Value" placeholder="Lead Value" onChange={event => setAmount(event.target.value)} onKeyPress={(event)=>{decimalOnly(event)}} value={amount} fullWidth variant="outlined" inputProps={{ maxLength: 8 }} style={{marginTop: 14}} />
                          <TextField required size='small' label="Contact Name" onChange={event => setContactName(event.target.value)} value={contactName} onKeyPress={(event)=>{nameOnly(event)}} fullWidth variant="outlined" style={{marginTop: 14}} />
                          
                          <TextField required size='small' label="Mobile" onChange={event => setMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={mobile} fullWidth variant="outlined"
                           style={{marginTop: 14}}
                           InputProps={{
                            maxLength: 10,
                            endAdornment: (
                              <InputAdornment position="end">
                                <FormControlLabel
                                  control={
                                    <Checkbox checked={checkedDuplicateMobile} onChange={event => setCheckedDuplicateMobile(event.target.checked)} />
                                  }
                                  label="Check Duplicate"
                                />
                              </InputAdornment>
                            ),
                            }}
                           />

                          <TextField size='small' label="Phone" onChange={event => setPhone(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={phone} fullWidth variant="outlined" style={{marginTop: 14}} />
                          <TextField size='small' label="Email" onChange={event => setEmail(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={email} fullWidth variant="outlined"
                           style={{marginTop: 14}}
                           InputProps={{
                            maxLength: 10,
                            endAdornment: (
                              <InputAdornment position="end">
                                <FormControlLabel
                                  control={
                                    <Checkbox checked={checkedDuplicateEmail} onChange={event => setCheckedDuplicateEmail(event.target.checked)} />
                                  }
                                  label="Check Duplicate"
                                />
                              </InputAdornment>
                            ),
                            }}
                           />
                          <TextField size='small' label="Address" onChange={event => setAddress(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={address} fullWidth variant="outlined" style={{marginTop: 14}} />
                          <TextField size='small' label="Pincode" onChange={event => setPincode(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={pincode} fullWidth variant="outlined" inputProps={{ maxLength: 6 }} style={{marginTop: 14}} />

                          <FormControl fullWidth size='small' style={{marginTop: 14}} >
                                  <InputLabel id="demo-simple-select-label">Rating</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={rating}
                                    label="Rating"
                                    onChange={event => setRating(event.target.value)}
                                  >
                                    <MenuItem value={""}>Select Rating</MenuItem>
                                    <MenuItem value="Hot" >Hot</MenuItem>
                                    <MenuItem value="Warm" >Warm</MenuItem>
                                    <MenuItem value="Cold" >Cold</MenuItem>
                                  </Select>
                          </FormControl>

                          <div style={{marginTop: 14}}>  
                            <TagsOptions defaultValues={tags} selectedTags={selectedTags} options={leadTagsList} />
                          </div>

                          <FormControl fullWidth size='small' style={{marginTop: 14}} >
                                  <InputLabel id="demo-simple-select-label">Source</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={source}
                                    label="Source"
                                    onChange={event => setSource(event.target.value)}
                                  >
                                    <MenuItem value={""}>Select Lead Source</MenuItem>
                                    {leadSourcesList?leadSourcesList.map((myRow,mykey)=>(
                                        <MenuItem key={'ct'+mykey} value={myRow.title}>{myRow.title}</MenuItem>
                                    )):null}
                                  </Select>
                           </FormControl>


                        </Grid>
                        <Grid item md={6} xs={12} >

                        <FormControl fullWidth size='small'  >
                                <InputLabel id="demo-simple-select-label">Channel</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={channelId}
                                  label="Channel"
                                  required
                                  onChange={event => handleChannelId(event.target.value)}
                                >
                                  <MenuItem value={0}>Select Channel</MenuItem>
                                  {channelList?channelList.map((myRow,mykey)=>(
												            <MenuItem key={'ct'+mykey} value={myRow.autoId}>{myRow.channelName}</MenuItem>
											            )):null}
                                </Select>
                          </FormControl>

                            <FormControl fullWidth size='small' style={{marginTop: 14}} >
                              <InputLabel id="demo-simple-select-label">Lead Status</InputLabel>
                              <Select
                                required
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={status}
                                label="Lead Status"
                                onChange={event => handleStatus(event.target.value)}
                              >                                 
                                <MenuItem value="noselect" >Select Status</MenuItem>
                                {(leadStatusList && leadStatusList.length>0)?leadStatusList.map((row,i)=>(
                                    <MenuItem key={'os'+i} value={row.status+'$#$'+row.parentStatus}>{row.status}</MenuItem>
                                 )):null}
                              </Select>
                            </FormControl>

                            {parentStatus==="Lost"?      
                            <FormControl fullWidth size='small' style={{marginTop: 14}} >
                              <InputLabel id="demo-simple-select-label">Lead Loss Reason</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={leadLossReason}
                                label="Lead Loss Reason"
                                onChange={event => setLeadLossReason(event.target.value)}
                              >                                 
                                <MenuItem value="noselect" >Select Loss Reason</MenuItem>
                                {(leadLossReasonsList && leadLossReasonsList.length>0)?leadLossReasonsList.map((row,i)=>(
                                    <MenuItem key={'os'+i} value={row.title}>{row.title}</MenuItem>
                                 )):null}
                              </Select>
                            </FormControl>
                            :null}

                              <FormControl fullWidth size='small' style={{marginTop: 14}} >
                                  <InputLabel id="demo-simple-select-label">Customer Type</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={leadAccountType}
                                    label="Customer Type"
                                    onChange={event => setLeadAccountType(event.target.value)}
                                  >
                                    <MenuItem value={""}>Select Customer Type</MenuItem>
                                    <MenuItem value="New" >New</MenuItem>
                                    <MenuItem value="Existing" >Existing</MenuItem>
                                  </Select>
                              </FormControl>

                          <TextField
                               label="Account Name"
                               onChange={event => setAccountName(event.target.value)}
                               value={accountName}
                               fullWidth
                               style={{marginTop: 14}}
                               size='small'
                               variant="outlined"
                               placeholder='Select Account'
                               InputLabelProps={{
                                shrink: true,
                               }}
                               InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectContacts()}} />
                                  </InputAdornment>
                                ),
                                }}
                               />

                                <TextField size='small' label="Designation" placeholder='Contact person designation' onChange={event => setDesignation(event.target.value)} value={designation} fullWidth variant="outlined" style={{marginTop: 14}} />
                                <TextField size='small' label="Company" onChange={event => setCompany(event.target.value)} value={company} fullWidth variant="outlined" style={{marginTop: 14}} />
                                <TextField size='small' label="Website" onChange={event => setWebsite(event.target.value)} value={website} fullWidth variant="outlined" style={{marginTop: 14}} />

                                <TextField
                                  label="Referral Partner"
                                  onChange={event => setPartnerAccountName(event.target.value)}
                                  value={partnerAccountName}
                                  fullWidth
                                  style={{marginTop: 14}}
                                  size='small'
                                  variant="outlined"
                                  placeholder='Select Referral Partner'
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectPartner()}} />
                                      </InputAdornment>
                                    ),
                                    }}
                                />

                                <FormControl fullWidth size='small' style={{marginTop: 14}} >
                                  <InputLabel id="demo-simple-select-label">Industry</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={industry}
                                    label="Industry"
                                    onChange={event => setIndustry(event.target.value)}
                                  >
                                    <MenuItem value={""}>Select Industry</MenuItem>
                                    {industryList?industryList.map((myRow,mykey)=>(
                                        <MenuItem key={'ct'+mykey} value={myRow.title}>{myRow.title}</MenuItem>
                                    )):null}
                                  </Select>
                                </FormControl>

                                <FormControl fullWidth size='small' style={{marginTop: 14}} >
                                  <InputLabel id="demo-simple-select-label">Campaign</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={campaignId+'#'+campaignName}
                                    label="Campaign"
                                    onChange={event => handleCampaign(event.target.value)}
                                  >
                                    <MenuItem value={"0#"}>Select Campaign</MenuItem>
                                    {(campaigns || []).map((myRow,mykey)=>(
                                        <MenuItem key={'ct'+mykey} value={myRow.autoId+'#'+myRow.campaignName} >{myRow.campaignName}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                                <TextField 
                                  label="Forecast Close Date"
                                  id="date"                                
                                  type="date"
                                  defaultValue={forecastCloseDate}
                                  fullWidth
                                  size="small"
                                  InputLabelProps={{
                                  shrink: true,
                                  }}
                                  onChange={event => setForecastCloseDate(event.target.value)}
                                  variant="outlined"
                                  style={{marginTop: 14}}
                                />

                                <Grid container spacing={2} style={{marginTop: 5}}>
                                  <Grid item md={8} xs={8} >
                                      <TextField
                                        label="Agent"
                                        onChange={event => setOwnerAlias(event.target.value)}
                                        value={ownerAlias}
                                        fullWidth
                                        size='small'
                                        variant="outlined"
                                        
                                        InputProps={{
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectUser()}} />
                                            </InputAdornment>
                                          ),
                                          }}
                                    />
                                  </Grid>
                                  <Grid item md={4} xs={4} >
                                    <FormControl fullWidth size='small'  >
                                      <InputLabel id="demo-simple-select-label">Visibility</InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={accessType}
                                        label="Visibility"
                                        onChange={event => setAccessType(event.target.value)}
                                      >
                                        <MenuItem value={1} >Public</MenuItem>
                                        <MenuItem value={2} >Private</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </Grid>


                           </Grid>

                    </Grid>


                  </Box>        


                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"											
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Wait...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }    
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>
      
        <ContactsSelect userObj={props.userObj} contactDetail={contactDetail} ref={childRefContacts} />
        <ContactsSelect userObj={props.userObj} contactDetail={partnerDetail} ref={childRefPartners} />
        <AgentSelect userObj={props.userObj} fetchDetail={userDetail} fetch={true} ref={childRefUser} />
        
    </>
  );

});

export default CustomizedDialogs;